/*eslint-disable */
import toast from '@/services/toast';
const $ = window.jQuery = require('jquery');
import countries from '@/services/country.json'
export default {
  name: 'my-core-team-list',
  components: {},
  props: [],
  data () {
    return {
      myCoreTeamListData:null,
      myCoreTeamListDataResults:[],
      countryList:[],
      removeUserFromOurList:false,
      removeUserId:'',
    }
  },
  computed: {

  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.myCoreTeamListMethod();
  },
  methods: {
    showRemovedModalFun(id){
      $("body").addClass("notConnectedUserBody");
      this.removeUserFromOurList = true
      this.removeUserId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeUserForTeamToTeamHeadFun', {
        id: this.removeUserId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("notConnectedUserBody");
          this.removeUserFromOurList = false
          this.removeUserId = ''
          this.myCoreTeamListMethod()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("notConnectedUserBody");
      this.removeUserFromOurList = false
      this.removeUserId = ''
    },
    myCoreTeamListMethod(){
      this.$store.dispatch('getMyCoreTeamFiltersFun', {filter_key:'connected'}).then((res) => {
        this.myCoreTeamListData = res.data.data
        this.myCoreTeamListDataResults = this.myCoreTeamListData.results
      })
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  }
}